import api from '@/utils/api'

export default {
  namespaced: true,
  state: {
    unreadCount: null,
    unreadCountInterval: null,
  },
  getters: {
    unreadCount(state) {
      return state.unreadCount
    },
    unreadCountInterval(state) {
      return state.unreadCountInterval
    },
  },
  mutations: {
    setCount(state, count) {
      state.unreadCount = count
    },
    setUnreadCountInterval(state, interval) {
      state.unreadCountInterval = interval
    },
    clearUnreadCountInterval(state) {
      if (state.unreadCountInterval) {
        clearInterval(state.unreadCountInterval)
      }
    },
  },
  actions: {
    async enableUnreadCountPolling({ commit, dispatch, getters }) {
      if (getters.unreadCountInterval) {
        return
      }
      const interval = setInterval(() => {
        dispatch('setUnreadCount')
      }, 5000)
      commit('setUnreadCountInterval', interval)
    },
    async disableUnreadCountPolling({ commit, getters }) {
      if (getters.unreadCountInterval) {
        commit('clearUnreadCountInterval')
      }
    },
    async setUnreadCount({ commit, dispatch }) {
      try {
        const result = await api.get('/messages/count')
        const { data: { unreadCount } } = result
        commit('setCount', unreadCount)
      } catch (err) {
        dispatch('disableUnreadCountPolling')
        throw err
      }
    },
  },
}
